import { useState } from "react";
import { useSubscription } from "./UseSubscription";

export function useObservableState(source) {
  const [state, setState] = useState(null);
  useSubscription(source, {
    next: (value) => {
      setState(value);
    },
  });
  return state;
}
